import { useEffect, useState } from "react";

import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";

const BotpressTribalKnowledgeDialog = ({
  open,
  entryRecord,
  dialogTitle = "Tribal Knowledge Entry",
  okMessage = "Ok",
  onAccept,
  onDelete,
  onClose,
}) => {
  const [editedEntry, setEditedEntry] = useState({
    id: null,
    topic: "",
    clarification: "",
    sourceFile: "Manual Entry",
    lineNumber: "",
  });

  useEffect(() => {
    if (entryRecord != null) {
      setEditedEntry({
        id: entryRecord.id ?? null,
        topic: entryRecord.topic ?? "",
        clarification: entryRecord.clarification ?? "",
        sourceFile: entryRecord.sourceFile ?? "Manual Entry",
        lineNumber: entryRecord.lineNumber ?? "",
      });
    }
  }, [entryRecord]);

  const updateField = (fieldName, value) => {
    setEditedEntry(previousEntry => ({
      ...previousEntry,
      [fieldName]: value,
    }));
  };

  const onAcceptEntry = () => {
    onAccept({
      ...editedEntry,
      topic: editedEntry.topic.trim(),
      clarification: editedEntry.clarification.trim(),
      sourceFile: editedEntry.sourceFile.trim() || "Manual Entry",
    });
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>{dialogTitle}</DialogTitle>

      <DialogContent>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            pt: 1,
          }}
        >
          <TextField
            label="Topic"
            value={editedEntry.topic}
            onChange={event => updateField("topic", event.target.value)}
            fullWidth
            required
          />

          <TextField
            label="Clarification"
            value={editedEntry.clarification}
            onChange={event => updateField("clarification", event.target.value)}
            fullWidth
            required
            multiline
            minRows={4}
          />

          <TextField
            label="Source File"
            value={editedEntry.sourceFile}
            onChange={event => updateField("sourceFile", event.target.value)}
            fullWidth
          />
        </Box>
      </DialogContent>

      <DialogActions>
        {editedEntry.id != null && (
          <Button color="error" onClick={() => onDelete(editedEntry)}>
            Delete
          </Button>
        )}

        <Box sx={{ flexGrow: 1 }} />

        <Button onClick={onClose}>Cancel</Button>

        <Button
          variant="contained"
          onClick={onAcceptEntry}
          disabled={!editedEntry.topic.trim() || !editedEntry.clarification.trim()}
        >
          {okMessage}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BotpressTribalKnowledgeDialog;
